import React from 'react';
import ReactDOM from 'react-dom';
import RegisterFormRoot from '../common/react/components/form/registration/RegisterFormRoot';
import SubscriptionForm from '../common/react/components/form/blog/SubscriptionForm';
import maintainLinkQueryParams from './maintainLinkQueryParams';
import setupLinkGAClickTracking from './setupLinkGAClickTracking';
import blogEmailSubscriptionEventListeners from '../common/react/components/blog/blogEmailSubscriptionEventListeners';
import blogHeaderEventListeners from '../common/react/components/blog/blogHeaderEventListeners';
import setupSegmentCarousel from './setupSegmentCarousel';
import setupSwipeCarousel from './setupSwipeCarousel';
import setupTemplateCTAPanel from './setupTemplateCTAPanel';
import queryAppAuthState from './queryAppAuthState';
import setupRegistrationModal from './setupRegistrationModal';
import setupNavigationHeader from './setupNavigationHeader';
import setupGuidePopupPanels from './setupGuidePopupPanels';
import setupGuideTableOfContentsNavigation from './setupGuideTableOfContentsNavigation';
import setupSocialShareButtons from './setupSocialShareButtons';
import { persistSessionArrivalAvenue } from '../common/react/components/form/registration/registrationUtils';
import { renderIslands } from '../common/react/components/island/Island';
import { SignupForm } from '../common/react/pages/home2025/components/slices/signup/SignupForm';
import { Navbar } from '../common/react/pages/home2025/components/navbar/Navbar';
import { CarouselEdges } from '../common/react/pages/home2025/components/slices/carousel/CarouselEdges';
import { sendABExperimentEvents } from '../common/react/components/analytics/ABIdentifier';

// track the arrival avenue for this session
persistSessionArrivalAvenue();

// maintain query params for links
maintainLinkQueryParams();

// Set up link click tracking
setupLinkGAClickTracking();

// Set up social share buttons
setupSocialShareButtons();

// query user's remote auth state of the app
queryAppAuthState();

// set up header fixed scroll, dropdown behaviour
var header = document.querySelector('.navigation-header');
if (header) setupNavigationHeader(header);

// attach register form to site
var mountNode = document.getElementById('register-form');
if (mountNode) ReactDOM.render(/*#__PURE__*/React.createElement(RegisterFormRoot, null), mountNode);

// set up registration modal and buttons
setupRegistrationModal();

// set up guide navigation
setupGuidePopupPanels();
setupGuideTableOfContentsNavigation();

// attach register form to site
var subscriptionFormMountNode = document.getElementById('subscription-form');
if (subscriptionFormMountNode) ReactDOM.render(/*#__PURE__*/React.createElement(SubscriptionForm, null), subscriptionFormMountNode);
var subscriptionSectionNode = document.getElementById('blog-email-subscription');
if (subscriptionSectionNode) blogEmailSubscriptionEventListeners();
var blogHeaderNode = document.getElementById('blog-header-floating');
if (blogHeaderNode) blogHeaderEventListeners();
var segmentCarouselSlices = document.querySelectorAll('.SegmentCarouselSlice');
var testamonialSlices = document.querySelectorAll('.TestimonalSlice');
if (window.innerWidth < 767) {
  testamonialSlices.forEach(setupSwipeCarousel);
  segmentCarouselSlices.forEach(setupSwipeCarousel);
} else {
  testamonialSlices.forEach(setupSegmentCarousel);
  segmentCarouselSlices.forEach(setupSegmentCarousel);
}
if (document.querySelector('.TemplateCTAPanel')) setupTemplateCTAPanel();
renderIslands({
  SignupForm: SignupForm,
  Navbar: Navbar,
  CarouselEdges: CarouselEdges
});

// do this last to allow earlier calls to trigger their own experiments
sendABExperimentEvents();